import React, { memo, useMemo } from "react";
import globalMU from "globalMU";
import { DadosRma } from "app/api/classes/ProdutoApi";

const estiloTabela = require('../../../../estilos/tabelas.module.scss').default;

export type RmaProps = {
  dados: DadosRma[];
  produto: string;
  descricao: string;
}

const tableHead = (
  <div className="_table-row">
    <div id="Rma_colCliente" className={`_table-cell _font-bold ${estiloTabela.tableCellHeader}`}>Cliente</div>
    <div id="Rma_colOrdemServico" className={`_table-cell _font-bold ${estiloTabela.tableCellHeader}`}>Ordem de Serviço</div>
    <div id="Rma_colQuantidade" className={`_table-cell _font-bold _text-right ${estiloTabela.tableCellHeader}`}>Quantidade</div>
    <div id="Rma_colDataEntrada" className={`_table-cell _font-bold ${estiloTabela.tableCellHeader}`}>Data Entrada</div>
    <div id="Rma_colHistoricoRMA" className={`_table-cell _font-bold ${estiloTabela.tableCellHeader}`}>Histórico RMA</div>
  </div>
);

export const Rma = memo((props: RmaProps) => {

  const descricaoProdutoSelecionado = useMemo(() => (
    <div className={estiloTabela.InformacoesProduto}
      id="Rma_descricaoProdutoSelecionado"
    >
      <div className={estiloTabela.primeiraColuna}>Produto</div>
      <div style={{ marginTop: "7px" }}>{props.produto}</div>
      <div className={estiloTabela.primeiraColuna}>Descrição</div>
      <div style={{ marginTop: "7px" }}>{props.descricao}</div>
    </div>
  ), [props.produto, props.descricao]);

  const tableBody = useMemo(() => props.dados?.map((value, index) => (
    <div key={value.OrdemServico ?? index} className="_table-row">
      <div className={`_table-cell ${estiloTabela.tableCellBody}`}>{value.Cliente}</div>
      <div className={`_table-cell ${estiloTabela.tableCellBody}`}>{value.OrdemServico}</div>
      <div className={`_table-cell _text-right ${estiloTabela.tableCellBody}`}>
        {globalMU.formatarValorNumerico(value.Quantidade, 0)}
      </div>
      <div className={`_table-cell ${estiloTabela.tableCellBody}`}>
        {value.DataEntrada ? globalMU.formatDate(value.DataEntrada) : ''}
      </div>
      <div className={`_table-cell ${estiloTabela.tableCellBody}`}>{value.HistoricoRMA}</div>
    </div>
  )), [props.dados]);

  const totalQuantidade = useMemo(
    () => props.dados?.reduce((total, x) => total + x.Quantidade, 0) ?? 0,
    [props.dados]
  );

  return (
    <>
      {descricaoProdutoSelecionado}

      <br />

      <div id="Rma_containerRolavel" className={estiloTabela.containerRolavel}>
        <div id="Rma_tabela" className={`_table _w-full _border-collapse`}>
          <div id="Rma_tabelaHead" className="_table-header-group">
            {tableHead}
          </div>
          <div id="Rma_tabelaBody" className="_table-row-group">
            {tableBody}
          </div>
        </div>
      </div>

      <br />

      <div id="Rma_totais">
        <div className="_text-lg _font-bold _text-blue-500 _mb-4">Totais</div>
        <div style={{ display: "grid", gridTemplateColumns: "192px auto", alignItems: "stretch", font: "13px/1.54 arial, sans-serif", color: "#333739" }}>
          <label id="Rma_labelTotalQuantidade" style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", backgroundColor: "#e4e6e8", padding: "6px", fontWeight: 400 }}>
            Quantidade
          </label>
          <div id="Rma_valorTotalQuantidade" style={{ display: "flex", alignItems: "center", padding: "6px" }}>
            {globalMU.formatarValorNumerico(totalQuantidade, 0)}
          </div>
        </div>
      </div>

      <section style={{ marginBottom: "100px" }} />
    </>
  );
});
